export type tacxCCodes = 0x30 | 0x31 | 0x32 | 0x33;

export const commandCodesTacx = {
    BASIC_RESISTANCE: 0x30,
    TARGET_POWER: 0x31,
    WIND_RESISTANCE: 0x32,
    TRACK_RESISTANCE: 0x33,
};
